import { type Repub } from '@cx-modules/constants';
import { type Country, type StateCode } from '@cx-modules/types';

export const GoogleTagManagerHead = ({
	country,
	countryCode,
	gtmId,
	repub,
	shouldRender,
	state,
	userGroup,
	userId,
}: {
	country: string;
	countryCode: Country;
	gtmId: string;
	repub: Repub;
	shouldRender: boolean;
	state: StateCode | '';
	userGroup: string;
	userId: string;
}) => {
	return (
		<>
			{shouldRender && (
				<script
					async={true}
					src={`https://www.googletagmanager.com/gtm.js?id=${gtmId}`}
				/>
			)}
			<script
				dangerouslySetInnerHTML={{
					__html: `
						window.dataLayer = window.dataLayer || [];
						window.dataLayer.push({
							'gtm.start': new Date().getTime(),
							event: 'gtm.js'
						});
						window.dataLayer.push({
							country: '${country}',
							countryCode: '${countryCode}',
							repub: '${repub}',
							state: '${state ?? ''}',
							userId: '${userId}',
							userGroup: '${userGroup}',
						});
					`,
				}}
				id="gtag-init"
			/>
		</>
	);
};
